/**
 * IntelliGems A/B Test: Mobile PDP thumbnails
 *
 * Control (A): data-mobile-thumbnail="false" — dots + arrows
 * Variant (B): data-mobile-thumbnail="true"  — image thumbnails
 *
 * Dev preview: ?mobile_thumbnail_test=b
 * Mobile only (< 1008px).
 */
(function () {
  'use strict';

  if (window.__mobileThumbnailABTestInit) return;
  window.__mobileThumbnailABTestInit = true;

  var BODY_ATTR = 'data-mobile-thumbnail';
  var MOBILE_MQ = '(max-width: 1007px)';
  var applying = false;
  var debounceTimer = null;
  var resizeTimer = null;
  var variantActive = null;
  var handlersBound = false;

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('mobile_thumbnail_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function isVariantB() {
    if (isDevVariantB()) return true;

    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;

    return isTruthy(body.getAttribute(BODY_ATTR)) || isTruthy(html.getAttribute(BODY_ATTR));
  }

  function getProductSection() {
    return document.querySelector('[data-section-type="product"]');
  }

  function getFlickityInstance(element) {
    if (typeof Flickity !== 'undefined' && Flickity.data) {
      return Flickity.data(element);
    }
    return element._flkty || element.flickity || null;
  }

  function setupThumbnailHandlers(productSection, thumbnailsNav) {
    if (handlersBound || !productSection || !thumbnailsNav) return;

    var thumbnailLinks = thumbnailsNav.querySelectorAll('.Product__SlideshowNavImage--mobile');
    var slideshowEl = productSection.querySelector('.Product__Slideshow');
    var scroller = thumbnailsNav.querySelector('.Product__SlideshowNavScroller--mobile');

    if (!slideshowEl || thumbnailLinks.length === 0) return;

    handlersBound = true;

    if (scroller) scroller.scrollLeft = 0;

    thumbnailLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (!isMobile() || !isVariantB()) return;

        var mediaId = link.getAttribute('data-media-id');
        if (!mediaId) return;

        thumbnailLinks.forEach(function (thumb) {
          thumb.classList.remove('is-selected');
        });
        link.classList.add('is-selected');

        var flickity = getFlickityInstance(slideshowEl);
        if (flickity && flickity.cells) {
          for (var i = 0; i < flickity.cells.length; i++) {
            if (flickity.cells[i].element.getAttribute('data-media-id') === mediaId) {
              flickity.select(i);
              return;
            }
          }
        }

        var targetSlide = slideshowEl.querySelector('[data-media-id="' + mediaId + '"]');
        if (targetSlide) {
          targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });

    slideshowEl.addEventListener('settle.flickity', function () {
      if (!isMobile() || !isVariantB()) return;

      var flickity = getFlickityInstance(slideshowEl);
      if (!flickity || !flickity.selectedElement) return;

      var selectedMediaId = flickity.selectedElement.getAttribute('data-media-id');
      if (!selectedMediaId) return;

      thumbnailLinks.forEach(function (thumb) {
        if (thumb.getAttribute('data-media-id') === selectedMediaId) {
          thumb.classList.add('is-selected');
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } else {
          thumb.classList.remove('is-selected');
        }
      });
    });
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      var mobile = isMobile();

      document.documentElement.classList.toggle('mobile-thumbnail-b', variantB);

      var productSection = getProductSection();
      if (!productSection) {
        variantActive = variantB;
        return;
      }

      var thumbnailsNav = productSection.querySelector('.Product__SlideshowMobileNav--thumbnails');
      var dotsNav = productSection.querySelector('.Product__SlideshowMobileNav--dots');

      if (!thumbnailsNav) {
        variantActive = variantB;
        return;
      }

      if (!mobile) {
        thumbnailsNav.style.display = '';
        if (dotsNav) dotsNav.style.display = '';
        variantActive = variantB;
        return;
      }

      if (variantB) {
        thumbnailsNav.style.display = 'flex';
        if (dotsNav) dotsNav.style.display = 'none';
        setupThumbnailHandlers(productSection, thumbnailsNav);
      } else {
        thumbnailsNav.style.display = 'none';
        if (dotsNav) dotsNav.style.display = '';
      }

      variantActive = variantB;
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    applyVariant();

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (
          mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active'
        ) {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scheduleApply, 150);
    });

    document.addEventListener('gem:variant:changed', scheduleApply);
  }

  window.MobileThumbnailABTest = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'true');
      scheduleApply();
    },
    disable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'false');
      scheduleApply();
    },
    refresh: scheduleApply
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
